import { NormalTextInputField } from "@/components";
import React from "react";

const InvestorsCornerThirdTabFormFields = ({
  selectedTab,
  formData,
  isFetching,
  handleTextInputChange,
}) => {
  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="listed-companies-or-investors-heading"
            fieldName="listed-companies-or-investors-heading"
            placeholderText="Heading"
            inputValue={
              formData?.["listed-companies-or-investors-heading"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Description"
            fieldId="listed-companies-or-investors-description"
            fieldName="listed-companies-or-investors-description"
            placeholderText="Description"
            inputValue={
              formData?.["listed-companies-or-investors-description"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default InvestorsCornerThirdTabFormFields;
